'use strict';

angular.module('msCore').filter('transformEntity', [function () {
  return function (text) {
    if (text) {
      return String(text).replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, ' ');
    }
    return '';
  };
}]);